import React from 'react';

import { Box, PhoneIcon } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useGetDetailsQuery } from '@epi-api/user';
import { StyledLink } from '@epi-shared/components/StyledLink/StyledLink.styles';

export const OnboardingSupportInformation = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { data: customerData } = useGetDetailsQuery();
  const isHidden =
    customerData?.isBenefitsSet &&
    customerData?.isEmployeesSet &&
    (customerData?.isMoneyTransfered || customerData?.isLoadInitiated);

  if (isHidden) return null;

  return (
    <Box
      display={'flex'}
      gap={0.5}
      alignItems="center"
      maxWidth={'1375px'}
      margin={'0 auto'}
      pb={5}
      pl={5}
      pr={5}
    >
      <Box pr={0.5}>
        <PhoneIcon />
      </Box>
      <Box color={theme.gray50}>
        {t('components.benefit_onboarding.support_information.text')}
      </Box>
      <StyledLink
        target="_blank"
        href={t('components.benefit_onboarding.support_information.link_url')}
      >
        {t('components.benefit_onboarding.support_information.link_button')}
      </StyledLink>
    </Box>
  );
};
